import { multicallAddresses } from '@pancakeswap/multicall'
// 수정
export default {
  masterChef: {
    97: '0xE641b73948FeBbD349C9Fd21C110eA9Dd384179C',
    56: '0xE641b73948FeBbD349C9Fd21C110eA9Dd384179C',
    5: '0xE641b73948FeBbD349C9Fd21C110eA9Dd384179C',
    1001: '0xF0681e41ee14467FF719BF86677c9F7246CA97FB',
    8217: '0xF90F20175539218044277D2862D301CF5ffaf190',
    2021: '0xA14a3778ED736965Fb47303bA1ac1bC57B2f5a61',
    84532: '0xf51Ab528017C3b999b5b0Fd00c9834832B192946',
    8453: '0x1eC6691bF64B946Ae7d9a657Ac4001e1Ca4Fe3C4',
  },
  masterChefV1: {
    97: '0xE641b73948FeBbD349C9Fd21C110eA9Dd384179C',
    56: '0xE641b73948FeBbD349C9Fd21C110eA9Dd384179C',
    5: '0xE641b73948FeBbD349C9Fd21C110eA9Dd384179C',
    1001: '0xF0681e41ee14467FF719BF86677c9F7246CA97FB',
    8217: '0xF90F20175539218044277D2862D301CF5ffaf190',
    2021: '0xA14a3778ED736965Fb47303bA1ac1bC57B2f5a61',
    84532: '0xf51Ab528017C3b999b5b0Fd00c9834832B192946',
    8453: '0x1eC6691bF64B946Ae7d9a657Ac4001e1Ca4Fe3C4',
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    56: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  lotteryV2: {
    97: '0x5790c3534F30437641541a0FA04C992799602998',
    56: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  multiCall: multicallAddresses,
  pancakeProfile: {
    56: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    1301: '',
  },
  pancakeBunnies: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  pointCenterIfo: {
    56: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  tradingCompetitionEaster: {
    56: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    97: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  tradingCompetitionFanToken: {
    56: '0xA8FECf847e28aa1Df39E995a45b7FCfb91b676d4',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  tradingCompetitionMobox: {
    56: '0x1C5161CdB145dE35a8961F82b065fd1F75C3BaDf',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  tradingCompetitionMoD: {
    56: '0xbDd9a61c67ee16c10f5E37b1D0c907a9EC959f33',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  easterNft: {
    56: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    97: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  cakeVault: {
    56: '0x1b3D8124d4Fb6085bde4d3511f850b00e371186f',
    97: '0x1b3D8124d4Fb6085bde4d3511f850b00e371186f',
    5: '0x1b3D8124d4Fb6085bde4d3511f850b00e371186f',
    1001: '0x05FC4BaEFe6E1C8715e06B5BE11e263BA657779c',
    8217: '0xE3Ef6D9D88787490549618F5792ecF472447d24e',
    2021: '0x1881895Fd353f0675DBaDcd1ef1558cAf4080160',
    84532: '0x91Cbc39ba725d1893a8436b71e0a000F5F250282',
    8453: '0xC0B2F93bBA73E34cFb5f35Eeec787542C902322C',
  }, // 수정
  cakeFlexibleSideVault: {
    56: '0x615e896A8C2CA8470A2e9dc2E9552998f8658Ea0',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  predictionsBNB: {
    56: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  predictionsCAKE: {
    56: '0x0E3A8078EDD2021dadcdE733C6b4a86E51EE8f07',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  chainlinkOracleBNB: {
    56: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  chainlinkOracleCAKE: {
    56: '0xB6064eD41d4f67e353768aA239cA86f4F73665a1',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  predictionsV1: {
    56: '0x516ffd7d1e0ca40b1879935b2de87cb20fc1124b',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    84532: '',
    8453: '',
  },
  bunnySpecialCakeVault: {
    56: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  bunnySpecialPrediction: {
    56: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  bunnySpecialLottery: {
    56: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    97: '0x382cB497110F398F0f152cae82821476AE51c9cF',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  bunnySpecialXmas: {
    56: '0x59EdDF3c21509dA3b0aCCd7c5ccc596d930f4783',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  farmAuction: {
    56: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    97: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  AnniversaryAchievement: {
    56: '0x787980da5491118C3cB33B21aB50c8c379D2C552',
    97: '0x981aE96378e770DE44F89cD9175E708f9EDB70a9',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  nftMarket: {
    56: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    97: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  nftSale: {
    56: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    97: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  pancakeSquad: {
    56: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    97: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  potteryDraw: {
    56: '0x01871991587d5671f3A2d4E2BcDC22F4E026396e',
    97: '0xDB9D365b50E62fce747A90515D2bd1254A16EbB9',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  // TODO: multi
  zap: {
    56: '0xD4c4a7C55c9f7B3c48bafb6E8643Ba79F42418dF',
    97: '0xD85835207054F25620109bdc745EC1D1f84F04e1',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  iCake: {
    56: '0x3C458828D1622F5f4d526eb0d24Da8C4Eb8F07b1',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  bCakeFarmBooster: {
    56: '0xE4FAa3Ef5A9708C894435B0F39c2B440936A3A52',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
  bCakeFarmBoosterProxyFactory: {
    56: '0x2C36221bF724c60E9FEE3dd44e2da8017a8EF3BA',
    97: '',
    5: '',
    1001: '',
    8217: '',
    2021: '',
    8453: '',
    84532: '',
  },
}
